<template>
  <v-container fill-height align-center>
    <v-layout align-center justify-center>
      <v-progress-circular v-if="loading" indeterminate color="primary" />
    </v-layout>
  </v-container>
</template>

<script>
import router from '@/router';

export default {
  name: 'Index',
  data() {
    return {
      loading: true,
    };
  },
  async created() {
    let jwt_token = this.$route.query.token;
    if (jwt_token) {
        this.$store.commit('USER_SET_JWTTOKEN', jwt_token);
    }
    let redirect = '/';
    try {
      const res = await this.$http.get('/api/user');
      this.$store.commit('USER_LOGIN', res.data.user);

      router.push(redirect);
    } catch (e) {
      console.log(e);
      console.log('redirect', redirect);
      localStorage.setItem('redirect_url', redirect);
      this.$store.commit('USER_LOGOUT');
      router.push('/login');
    }
  },
};
</script>